import { GetFieldDefBy } from "./GetFieldDefBy";

export function GetObjectLevel(dataObject) {
  if (dataObject == null) return null;

  var scLevelDef = dataObject.GetFieldDefByID("SubChartLevel");
  var objLevel = dataObject.GetFieldValue(scLevelDef);
  return objLevel;
}
